// extracted by mini-css-extract-plugin
module.exports = {"i1i8zjy7":"i1i8zjy7","i6el1g6":"i6el1g6","wcnkszl":"wcnkszl","shfe3ke":"shfe3ke"};